// 导出excel表格，对返回数据的处理
export const dealExcelRespose = (res, filename) => {
  const url = window.URL.createObjectURL(new Blob([res]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
}